import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function DocCheckAccessDialog({ open, onClose }) {
  const [users, setUsers] = useState([]);
  useEffect(() => { if (open) api.get("/doc-check/access").then((r) => setUsers(r.data)); }, [open]);
  const toggle = async (u) => {
    try {
      await api.put(`/doc-check/access/${u.user_id}`, { enabled: !u.can_doc_check });
      setUsers((xs) => xs.map((x) => (x.user_id === u.user_id ? { ...x, can_doc_check: !u.can_doc_check } : x)));
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md bg-white max-h-[85vh] overflow-y-auto" data-testid="doc-access-dialog">
        <DialogHeader><DialogTitle>Zugriff Unterlagen-Prüfung</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Admins haben immer Zugriff. Wählen Sie zusätzliche Mitarbeiter aus.</p>
        <div className="divide-y divide-slate-100 border border-slate-200">
          {users.filter((u) => u.role !== "admin").map((u) => (
            <label key={u.user_id} className="flex items-center gap-3 px-4 py-2.5 text-sm cursor-pointer hover:bg-slate-50" data-testid={`doc-access-${u.user_id}`}>
              <input type="checkbox" checked={!!u.can_doc_check} onChange={() => toggle(u)} data-testid={`doc-access-toggle-${u.user_id}`} />
              <span className="flex-1">{u.name}<span className="block text-[11px] text-slate-400">{u.email}</span></span>
            </label>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
